'use client';

import { Analytics } from '@vercel/analytics/react';
import { type ReactNode } from 'react';

import { QueryProvider } from '@/components/providers/QueryProvider';
import { TolgeeProvider } from '@/components/providers/TolgeeProvider';

import { AuthProviderWrapper } from './AuthProviderWrapper';
import { PostHogProvider } from './PostHogProvider';

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <AuthProviderWrapper>
      <PostHogProvider>
        <TolgeeProvider>
          <QueryProvider>
            {children}
            <Analytics />
          </QueryProvider>
        </TolgeeProvider>
      </PostHogProvider>
    </AuthProviderWrapper>
  );
}
